export const STRINGS = {
  title: 'Belong’s Open Standards govern how we take care of your\u00a0home.',
  quote: `
    We started Belong to bring peace of mind to Homeowners and Residents alike. 
    To do so, our Members need to trust that we’re going to take really great care of their homes. 
    That trust comes from knowing exactly how and why we operate the way we do.
  `,
  ceoName: 'Ale Resnik',
  ceoRole: 'CEO, Belong',
  responsibilities: 'Responsibilities',
  forHomeowners: 'For Homeowners',
  forResidents: 'For Residents',
  homeownerResponsibility: 'Homeowner Responsibility (Required)',
  habitabilityOrSafety: 'Habitability & Safety Issues',
  habitabilityOrSafetyDescription: '(Heat, Plumbing, Electrical, Etc.)',
  maintenanceAndAppliances: 'Maintaining Features & Appliances',
  maintenanceAndAppliancesDescription: '(Washers, Ovens, Pools, Etc.)',
  codeCompliance: 'Rental Code Compliance',
  codeComplianceDescription: '(Smoke Detectors, etc.)',
  emergencies: 'Emergencies',
  emergenciesDescription: '(Burst Pipes, Etc.)',
  integrityValue: 'Structural Integrity & Home Value',
  aestheticRentability: 'Aesthetics & Rentability',
  aestheticRentabilityDescription: '(During Periods Of Vacancy)',
  residentResponsibility: 'Resident Responsibility (Recommended)',
  properUseUpkeep: 'Proper Use & Upkeep',
  properUseUpkeepDescription: '(Appliances, Sanitation, Etc.)',
  consumables: 'Consumables',
  consumablesDescription: '(Light Bulbs, Batteries, Air Filters, Etc.)',
  upgradeRequests: 'Upgrade Requests & Personalization',
  routineServices: 'Routine Services Offered In-App',
  homeDamage: 'Damage To The Home',
  homeDamageDescription: '(Beyond Normal Wear & Tear)',
  returningHome: 'Returning The Home In The Condition Received',
  allStandards: 'All Standards',
  safetyAnd: 'Safety &',
  security: 'Security',
  functionalityAnd: 'Functionality &',
  habitability: 'Habitability',
  code: 'Code',
  compliance: 'Compliance',
  vacancy: 'Vacancy',
  reduction: 'Reduction',
  preventative: 'Preventative',
  viewAllStandards: 'VIEW ALL BELONG STANDARDS',
  copyLink: 'Copy Link',
  copied: 'Copied Link',
  noResults: 'No Standards Found',
  belongStandards:
    'Belong’s Open Standards govern how we take care of your\u00a0home.',
  learnMore: 'Learn More',
  anyFeedback: 'Have feedback for us?',
  emailFounders: 'EMAIL THE FOUNDERS',
  error1: 'Oops! Something went wrong.',
  error2: 'Mind giving it another\u00a0shot?',
  tryAgain: 'Try again',
};
